var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttachIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 25,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    id: "Attach"
  }, /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    x: -9.48508,
    y: -3.76866,
    fill: "none",
    height: 32.53731,
    width: 30.97015,
    id: "area"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "currentColor",
    d: "m10.00571,7.32901a0.63675,0.83621 0 0 0 -0.62436,0.85004l0,10.58683a3.40672,4.47388 0 0 1 -0.88141,3.00075a3.11869,4.09563 0 0 1 -2.22304,1.29092l-0.54446,0a3.06604,4.02649 0 0 1 -2.19516,-1.33972a3.38752,4.44866 0 0 1 -0.9576,-3.0097l0,-13.6551a2.29179,3.0097 0 0 1 0.69249,-2.15153a2.3401,3.07315 0 0 1 1.64204,-0.88746a2.21499,2.90884 0 0 1 1.59434,0.88257a2.35373,3.09104 0 0 1 0.65719,2.15641l0,12.75463a1.29393,1.69926 0 0 1 -1.16138,1.75376a1.25801,1.65208 0 0 1 -1.12979,-1.75376l0,-7.27616a0.62498,0.82075 0 1 0 -1.24996,0l0,7.27534a2.4324,3.19435 0 0 0 2.37913,3.39283a2.32896,3.05851 0 0 0 1.71017,-0.94196a2.67025,3.50671 0 0 0 0.70116,-2.45087l0,-12.75381a3.64147,4.78217 0 0 0 -1.02945,-3.36517a3.45441,4.53652 0 0 0 -4.97505,0a3.64147,4.78217 0 0 0 -1.03688,3.36924l0,13.65916a4.71799,6.19592 0 0 0 1.3057,4.24775a4.25716,5.59072 0 0 0 3.04746,1.73749l0.54446,0a4.30237,5.6501 0 0 0 3.04127,-1.74888a4.66658,6.1284 0 0 0 0.9576,-1.88391a4.47271,5.8738 0 0 0 0.35678,-2.29307l0,-10.59659a0.63117,0.82889 0 0 0 -0.62126,-0.85004z",
    "data-name": "attach",
    id: "attach-2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachIcon);
export default __webpack_public_path__ + "static/media/attach_icon.f7242806aa2bc38f2ce82f67e196cc63.svg";
export { ForwardRef as ReactComponent };